import * as Yup from 'yup';

export const MessageSchema = Yup.object({
  Message: Yup
    .string()
    .required("Enter Question")
  });